import React from "react";
import { BasePaymentPrefDisplay } from "../../../PaymentPrefConsolidated/Components/BasePaymentPrefDisplay";
import { ExistingPaymentPrefDetails } from "../../../PaymentPrefConsolidated/Components/ExistingPaymentPrefDetails";
import { PaymentPrefDisplayCardContainer } from "../../../PaymentPrefConsolidated/Components/PaymentPrefDisplayCardContainer";
import { getPaymentMethodIconType } from "../../../PaymentPrefConsolidated/Components/PaymentPrefDisplayCardContainer/utils";
import type { DetailedPaymentPrefUnionObjectType } from "../../../PaymentPrefConsolidated/common/types";

export type PayeePaymentPrefDisplayCardProps = {
  /** Payment preference data to display */
  paymentPref: DetailedPaymentPrefUnionObjectType;
  /** Whether to display reveal details functionality (defaults to true) */
  displayRevealDetails?: boolean;
};

/**
 * Card component for displaying existing payment preference information in payee workflows.
 *
 * This component wraps BasePaymentPrefDisplay in a card container with an icon and shows
 * reveal details functionality by default. For advanced features like accessory content,
 * field visibility configuration, and default expanded state, use ExistingPaymentPrefDisplay directly.
 */
export const PayeePaymentPrefDisplayCard: React.FC<PayeePaymentPrefDisplayCardProps> = ({
  paymentPref,
  displayRevealDetails = true,
}: PayeePaymentPrefDisplayCardProps) => {
  const iconType = getPaymentMethodIconType(paymentPref);

  return (
    <PaymentPrefDisplayCardContainer iconType={iconType}>
      <BasePaymentPrefDisplay
        paymentPref={paymentPref}
        displayRevealDetails={displayRevealDetails}
        renderDetails={() => <ExistingPaymentPrefDetails paymentPrefId={paymentPref.id!} />}
        defaultExpanded={true}
      />
    </PaymentPrefDisplayCardContainer>
  );
};
